export default __webpack_public_path__ + "static/media/no-vacancy.aa778d0a.png";